import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"kv\"><div class=\"caption\"><h1>電力人才萌芽</h1></div></div><section class=\"sect1\"><div class=\"ctx\"><div class=\"sectTit\">台灣民間電力人才的萌芽與茁壯</div><br><div class=\"left\"><div>1990 年代，國內經濟快速發展、用電迅速成長，於是政府開放民間投資興建電廠以加速電源開發，和平電力就是那時第一批核准設立的民營電廠。</div><br><div>身為台灣第一代的民營電廠，和平電力成立之初曾面臨缺乏有經驗人才的窘境，當時有電廠資歷的皆隸屬國營事業台電，民營公司如何將手握鐵飯碗的人才吸引過來？這真是難上加難！因此和平電力培訓自己的員工成當務之急。</div><br><div>新人進來後，當務之急是將新人訓練成電廠專業人員，但問題又來了，除了台電之外，台灣並無電廠經營維護的相關課程或講師可聘用，因此當時和平電力還曾情商台電協助代訓電廠新進人員。</div></div><div class=\"right\"><div class=\"imgContainer1-1\"><div class=\"imgTit\">2000 年建廠初期</div></div></div><div class=\"clear\"></div></div></section><section class=\"sect2\"><div class=\"ctx\"><div class=\"sectTit\">草創時期 人才培力</div><div class=\"gallery\"><div class=\"left\"><div class=\"imgContainer2-1\"></div><div class=\"imgContainer2-2\"></div><div class=\"imgContainer2-3\"></div></div><div class=\"right\"><div class=\"imgContainer2-4\"></div></div></div></div></section>", 3)
const _hoisted_4 = { class: "sect3" }
const _hoisted_5 = { class: "ctx" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "西元 2000 年和平電力舉辦大型招募活動，租借花蓮高商校區舉辦大型考試及面試，共招募了 188 位電廠生力軍，在當時花蓮還成了重要地方新聞。", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "2001 年 1 月和平電力從新進人員中挑選出約 80 人做為種子教官，分成兩組參加培訓專班課程，3 月底基礎課程結束後，正式邁入第二階段的訓練 - 由 Alstom 原廠技師帶領專業訓練。將人員分成不同組別，針對電廠不同設備，進行現場的操作及學理解說，讓學員有更進一步的認識。", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, "在各路電力界英雄的努力下，和平電廠一號機組及二號機組分別於 2002 年 6 月 1 日及同年 9 月 6 日宣告商轉，這一年和平電力母公司台泥企業團正式跨入民營電廠的能源產業版圖，與電網上的機組共同扛起電源供應的重責大任，和平工業區內的循環經濟產業鏈也正式啟動。", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "sectTit" }, "和電眾生相", -1)
const _hoisted_10 = { class: "employee" }
const _hoisted_11 = { class: "left" }
const _hoisted_12 = { class: "name" }
const _hoisted_13 = { class: "job" }
const _hoisted_14 = { class: "right" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_16 = { class: "flag" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "seniority" }, "年資", -1)
const _hoisted_18 = { class: "year" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createElementVNode("article", null, [
      _hoisted_1,
      _createElementVNode("section", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _hoisted_7,
          _hoisted_8,
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.employee, (row, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "item",
                key: idx
              }, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", {
                    class: "avatar",
                    style: _normalizeStyle(_ctx.setAvatar(row.avatar))
                  }, null, 4),
                  _createElementVNode("div", _hoisted_12, _toDisplayString(row.name), 1),
                  _createElementVNode("div", _hoisted_13, _toDisplayString(row.job), 1)
                ]),
                _createElementVNode("div", _hoisted_14, _toDisplayString(row.desp), 1),
                _hoisted_15,
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("div", _hoisted_18, _toDisplayString(row.year), 1)
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _createVNode(_component_Footer)
  ], 64))
}